import { render, staticRenderFns } from "./Residency.vue?vue&type=template&id=04f52084&scoped=true&"
import script from "./Residency.ts?vue&type=script&lang=ts&"
export * from "./Residency.ts?vue&type=script&lang=ts&"
import style0 from "./Residency.vue?vue&type=style&index=0&id=04f52084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f52084",
  null
  
)

export default component.exports